import { RangeClass } from "../../../interfaces/classification";
// eslint-disable-next-line max-len
import { RangePayload } from "../../../components/Classification/components/ClassificationRenderers/RangeClassificationRenderer";

const ACCURACY_LIMIT = 0.000001;

export const getRangeValues = (
  { from, to }: Pick<RangeClass, "from" | "to">,
  isDouble: boolean,
  isDate: boolean,
  index: number,
): Pick<RangeClass, "from" | "to"> => {
  return {
    from: from !== null && index !== 0 ? (isDate ? from : isDouble ? +from : +from + 1) : from,
    to,
  };
};

export const getRangeCommonValues = (
  values: RangeClass[],
  isDouble: boolean,
  index: number,
): Pick<RangePayload, "min" | "max" | "firstFromMax" | "lastToMin"> => {
  const min =
    (values[index] && values[index].from && +(+values[index].from + (isDouble ? ACCURACY_LIMIT : 1)).toFixed(6)) ||
    void 0;
  const max =
    (values[index + 1] &&
      values[index + 1].to &&
      +(+values[index + 1].to - (isDouble ? ACCURACY_LIMIT : 1)).toFixed(6)) ||
    void 0;
  const firstFromMax = values && values[0] && (isDouble ? +values[0].to - ACCURACY_LIMIT : +values[0].to);
  const lastToMin =
    values &&
    values[values.length - 1] &&
    (isDouble ? +values[values.length - 1].from + ACCURACY_LIMIT : +values[values.length - 1].from + 1);

  return {
    min,
    max,
    firstFromMax,
    lastToMin,
  };
};
